export const BAR_SCALE_CATEGORY_KEY = 'charting' as const;
export const BAR_SCALE_COMPONENT_KEY = 'barScale' as const;
